<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">

                <macrotags-form :macrotag="macrotag" :loader="loader" @click="storeMacrotag(macrotag)" :showLabels="false"></macrotags-form>

            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import macrotagsApi from '../../api/macrotags'
  import macrotagsForm from './Form.vue'
  import Macrotag from '../../models/macrotag'

  export default {

    components: {
      macrotagsForm
    },
    data () {
      return {
        macrotag: new Macrotag(),
        loader: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Inserisci nuovo macrotag',
        createButton: {display: false}
      })
    },

    methods: {
      storeMacrotag (macrotag) {
        this.loader = true
        macrotag.archive_id = this.$store.state.profile.profile.archive.data.id
        macrotagsApi.store(macrotag)
          .then((response) => {
            toastr.success('Il macrotag è stato inserito correttamente')
            this.$router.push('/macrotags')
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/macrotags/Create.vue